module.exports = __webpack_public_path__ + "img/UOB.b6aa856f.svg";